import { FC } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import styled from 'styled-components';

import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';

const StayInTouch: FC<any> = ({ data }) => (
	<Wrapper>
		<MobTopGrad src="/images/chatbots/StayMobTopGrad.png" />

		<MobBottomGrad src="/images/chatbots/StayMobBottomGrad.png" />

		<LeftGrad src="/images/chatbots/StayLeftGrad.png" />

		<RightGrad src="/images/chatbots/StayRightGrad.png" />

		<ScrollAnimation animateOnce animateIn="fadeInUp">
			<Title>{data?.text?.title}</Title>

			<Description>
				<img
					alt={data?.descriptionIcon?.name}
					src={getImage(data?.descriptionIcon)}
				/>

				{parseHTML(data?.text?.description)}
			</Description>

			<RowWrapper>
				{data?.infoRow?.map((tile, index) => (
					<ScrollAnimation
						key={`cb_stay_info_tile_${index}`}
						animateOnce
						offset={0}
						animateIn="fadeInUp"
						delay={(index + 1) * 200}
					>
						<InfoTile>
							<PhotoWrapper className="photo-wrapper">
								<picture>
									<img alt={tile?.icon?.name} src={getImage(tile?.icon)} />
								</picture>
							</PhotoWrapper>

							<InfoTileText className="text-wrapper">
								{parseHTML(tile?.description)}
							</InfoTileText>
						</InfoTile>
					</ScrollAnimation>
				))}
			</RowWrapper>
		</ScrollAnimation>
	</Wrapper>
);

const MobTopGrad = styled.img`
	display: none;

	@media (max-width: 375px) {
		display: block;
		position: absolute;
		left: 0;
		top: -4%;
	}
`;

const MobBottomGrad = styled.img`
	display: none;

	@media (max-width: 375px) {
		display: block;
		position: absolute;
		right: 0;
		top: 19%;
	}
`;

const LeftGrad = styled.img`
	position: absolute;
	left: 6%;
	top: -11%;

	@media (max-width: 1400px) {
		top: -11%;
		width: 68%;
		left: 0;
	}

	@media (max-width: 1400px) {
		top: 13%;
	}

	@media (max-width: 800px) {
		width: 100%;
		top: 43%;
	}

	@media (max-width: 500px) {
		top: 49%;
	}

	@media (max-width: 375px) {
		display: none;
	}
`;

const RightGrad = styled.img`
	position: absolute;
	right: 0;
	top: -35%;

	@media (max-width: 800px) {
		width: 100%;
		top: -24%;
	}

	@media (max-width: 500px) {
		width: 100%;
		top: -12%;
	}

	@media (max-width: 375px) {
		display: none;
	}
`;

const Wrapper = styled.div`
	position: relative;
	margin-top: 120px;
	padding: 60px 15px;
	width: 100%;
	max-width: 100%;
	background-color: #fbfaff;
	overflow: hidden;
`;

const Title = styled.h2`
	font-family: var(--font-sans);

	font-weight: var(--font-bold);
	font-size: 42px;
	line-height: 50px;
	color: var(--color-purple);
	text-align: center;
	max-width: 100%;
	margin: 25px auto 24px;

	@media (max-width: 800px) {
		font-size: 40px;
		margin-bottom: 15px;
	}

	@media (max-width: 500px) {
		font-size: 28px;
		line-height: 32px;
	}
`;

const Description = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 40px;
	font-family: var(--font-sans);
	z-index: 2;
	color: var(--color-purple);

	font-weight: var(--font-bold);
	font-size: 14px;
	line-height: 15px;
	text-align: center;
	text-transform: uppercase;
	margin: 0 auto 30px;
	width: 241px;
	max-width: 100%;
	text-align: center;
	background-color: var(--color-white);
	border-radius: 12px;
	img {
		margin-right: 10px;

		@media (max-width: 800px) {
			margin: 0 16px 0 20px;
		}
	}

	@media (max-width: 800px) {
		font-size: 13px;
		margin-bottom: 0;
	}

	@media (max-width: 500px) {
		font-size: 12px;
		line-height: 15px;
	}
`;

const InfoTile = styled.div`
	border-left: none;
	width: 100%;

	@media (max-width: 800px) {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
`;

const RowWrapper = styled.div`
	display: flex;
	justify-content: space-around;
	max-width: 100%;
	width: 59%;
	margin: 0 auto;
	z-index: 3;

	@media (max-width: 1500px) {
		width: 77%;
	}

	@media (max-width: 1300px) {
		width: 90%;
	}

	@media (max-width: 1180px) {
		width: 100%;
	}

	@media (max-width: 1080px) {
		width: 940px;
	}

	@media (max-width: 800px) {
		flex-direction: column;
		align-items: center;
	}
`;

const PhotoWrapper = styled.div`
	align-items: center;
	width: 100%;
	margin: 0 auto;
	z-index: 10;

	img {
		display: block;
	}

	img,
	svg {
		margin: 20px auto 0;
		height: 100%;
		max-height: 374px;

		@media (min-width: 768px) and (max-width: 1023px) {
			max-height: 300px;
		}
	}

	p {
		display: block;
		margin-left: auto;
		margin-right: auto;
		max-width: 100%;
		max-height: 100%;
	}

	@media (max-width: 800px) {
		margin-top: 15px;
		margin-bottom: 24px;
	}
`;

const InfoTileText = styled.div`
	font-family: var(--font-sans);

	font-size: 28px;
	line-height: 35px;
	text-align: center;
	color: var(--color-black);
	max-width: 95%;
	margin: 0 auto;
	width: 89%;

	@media (max-width: 800px) {
		max-width: 100%;
		width: 100%;
		margin-top: -20px;
	}

	@media (max-width: 500px) {
		font-size: 22px;
		line-height: 30px;
	}
`;
export default StayInTouch;
